import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {NewResponsePayloadSet, NewsResponsePayload} from '../../../shared/models/api';
import {RequestNewsParams} from '../../../shared/models/news';
import {AppActions} from '../../actions';

export interface NewsState {
  latest: NewsResponsePayload[] | null;
  selection: NewsResponsePayload[];
  selectionLoaded: boolean;
  page: number;
  byId: NewResponsePayloadSet | null;
  from: string | null;
  to: string | null;
  moreNewsAvailable: boolean;
  isLoading: boolean;
}

const initialState: NewsState = {
  latest: null,
  selection: [],
  selectionLoaded: false,
  page: 1,
  byId: null,
  from: null,
  to: null,
  moreNewsAvailable: false,
  isLoading: false,
};

export const newsSlice = createSlice<NewsState, SliceCaseReducers<NewsState>>({
  name: '@@eskso/news',
  initialState,
  reducers: {
    setLatestNews: (state, action: PayloadAction<NewsResponsePayload[]>) => {
      state.latest = action.payload;
    },
    setNews: (state, action: PayloadAction<NewsResponsePayload[]>) => {
      state.selection = action.payload;
      state.selectionLoaded = true;
    },
    setNewsById: (state, action: PayloadAction<NewResponsePayloadSet | null>) => {
      state.byId = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setDateRange: (state, action: PayloadAction<RequestNewsParams | null>) => {
      state.from = action.payload?.from ?? null;
      state.to = action.payload?.to ?? null;
    },
    setMoreNewsAvailable: (state, action: PayloadAction<boolean>) => {
      state.moreNewsAvailable = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const news = newsSlice.reducer;
